
const requiredChars = [
  'abcdefghijklmnopqrstuvwxyz',
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  '0123456789',
  "!@#$%^&*'()+,-./:;<=>?[]^_`{}|~",
]
const lettersAndNumbers = requiredChars.slice(0, 3).join('')
const allChars = requiredChars.join('')
export const generatePassword = () => {
  // 随机选择第一个字符（仅限字母和数字）
  const firstLetter = [lettersAndNumbers[Math.floor(Math.random() * lettersAndNumbers.length)]]
  // 确保密码包含至少一个小写字母、大写字母、数字和特殊字符
  const requiredLetter = requiredChars.map((charSet) => charSet[Math.floor(Math.random() * charSet.length)])
  // 填充剩余字符（包括确保字符）到达指定长度
  const otherLetter = []
  while (otherLetter.length < 8 - requiredLetter.length - 1) {
    otherLetter.push(allChars[Math.floor(Math.random() * allChars.length)])
  }

  return [...firstLetter, ...requiredLetter, ...otherLetter].join('')
}

// eslint-disable-next-line no-useless-escape
export const pwdReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*"'()+,-./:;<=>?\[\]^_`{|}~])[A-Za-z0-9!@#$%^&*"'()+,-./:;<=>?\[\]^_`{|}~]{8,32}$/


export const pwdErrInfo = '密码需为8-32位的大小写字母、数字和符号组成'

export function validatePwd(rule, value, callback) {
  if (!pwdReg.test(value)) {
    callback(new Error(pwdErrInfo))
  } else {
    callback()
  }
}
